<template>
  <div class="layout_wrapper" v-if="mainPath !== 'login'">
    <TheAside />
    <div class="layout_page">
      <TheNavBar />
      <router-view></router-view>
    </div>
  </div>
  <div class="layout_wrapper" v-if="mainPath === 'login'">
    <router-view></router-view>
  </div>
</template>

<script setup>

import TheAside from "@/components/layout/TheAside.vue";
import TheNavBar from "@/components/layout/TheNavbar.vue";
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { isTokenExpired } from "./utils/common";
const route = useRoute();
const router = useRouter();
const store = useStore();
const mainPath = computed(() =>  route.path.split("/")[1]);
onMounted(() => {
  const token = isTokenExpired(localStorage.getItem("access_token"));
  if (token) {
    router.push("/login");
  } else {
    store.commit("admin/updateLoginStatus", true);
  }
});
</script>

<style lang="scss">
@use '@/assets/scss/comn/entry' as entry;
</style>
